<div class="container">
  <div
    class="w-100 mt-5 d-flex flex-column justify-content-center align-items-center"
  >
    <h1 class="fw-bolder display-1 text-info">401</h1>
    <p class="display-5">Not Authorized</p>
    <p>Please try to login again</p>
    <p-button severity="info" (click)="redirectAndLogin()">Login</p-button>
    <p class="display-8 d-flex gap-2 align-items-center">
      <i class="pi pi-info-circle"></i
      ><span
        >If issue still persists, please contact Application Administrator
      </span>
    </p>
  </div>
</div>
